import { render, staticRenderFns } from "./pxItem.vue?vue&type=template&id=3282cfd4&scoped=true"
import script from "./pxItem.vue?vue&type=script&lang=js"
export * from "./pxItem.vue?vue&type=script&lang=js"
import style0 from "./pxItem.vue?vue&type=style&index=0&id=3282cfd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282cfd4",
  null
  
)

export default component.exports